import { PureComponent } from 'react';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleDown } from '@fortawesome/pro-regular-svg-icons/faChevronCircleDown';
import { faChevronCircleUp } from '@fortawesome/pro-regular-svg-icons/faChevronCircleUp';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class InnerTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sectionOpened: false,
    };
  }

  componentDidMount() {
    const { data } = this.props;

    this.setState({ sectionOpened: !!data[0].opened });
  }

  collapseTable() {
    const { sectionOpened } = this.state;

    this.setState({ sectionOpened: !sectionOpened });
  }

  render() {
    const { data } = this.props;
    const { sectionOpened } = this.state;

    return (
      <div className={cx('internalTable', { collapsed: !sectionOpened })}>
        <table>
          <tbody>
            {data.map((item) => (
              <tr className={Styles[item.class]} key={item.id}>
                <td>
                  {item.title}
                  <span className={Styles.subtitle}>{item.subtitle}</span>
                  {item.collapsible && (
                    <FontAwesomeIcon
                      icon={sectionOpened ? faChevronCircleUp : faChevronCircleDown}
                      onClick={() => this.collapseTable()}
                    />
                  )}
                </td>
                <td>
                  <span className={Styles[item.CityFALCON.class]}>{item.CityFALCON.text}</span>
                </td>
                <td>
                  <span className={Styles[item.Finance.class]}>{item.Finance.text}</span>
                </td>
                <td>
                  <span className={Styles[item.Twitter.class]}>{item.Twitter.text}</span>
                </td>
                <td>
                  <span className={Styles[item.Premium.class]}>{item.Premium.text}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default InnerTable;
